import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';
import { z } from 'zod';

export enum VideoStreamSupportedMediaType {
    MJPEG = 'MJPEG',
    RTP_BRIGHTSIGN = 'rtp_brightsign',
    HLS = 'hls',
    REACH = 'reach',
    YOUTUBE_LIVE = 'youtube_live',
    RTP_WINDOWS = 'rtp_windows',
    RTMP_WINDOWS = 'rtmp_windows',
    HDMI_WINDOWS = 'hdmi_windows',
    VLC = 'vlc',
    HDMI_BRIGHTSIGN = 'hdmi_brightsign',
}

const ZodVideoStreamSupportedMediaType = z.nativeEnum(VideoStreamSupportedMediaType);

export const ZodVideoStreamWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend(
    {
        stream_type: ZodVideoStreamSupportedMediaType,
        url: z.string().optional(),
        aspect_ratio: z.string().optional(),
        video_device: z.string().optional(),
        vlc_options: z.string().optional(),
    }
);

export type VideoStreamWidgetConfigurationDetails = z.infer<
    typeof ZodVideoStreamWidgetConfigurationDetails
>;

export const ZodVideoStreamWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.VIDEO_STREAM),
    config: ZodVideoStreamWidgetConfigurationDetails,
});

export type VideoStreamWidgetConfiguration = z.infer<typeof ZodVideoStreamWidgetConfiguration>;
